import { normalize, schema } from 'normalizr';

export const entity = 'vendorReturnItemTax';
export const endpoints = {
  edit: ({ vendorReturnID, itemID, vendorReturnItemTaxID, payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${vendorReturnID}/items/${itemID}/tax/${vendorReturnItemTaxID}`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnItemID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);
